import React, { DragEventHandler, forwardRef, PropsWithChildren, useState } from 'react';
import classNames from 'classnames';
import { DropArea } from './DropArea';
import { createFileUploaderRef, FileUploaderForward, UploadError, useFileUploader } from './FileUploader';
import { DropzoneBody } from './partials/DropzoneBody';
import styles from './Dropzone.module.scss';

export const Dropzone = forwardRef<FileUploaderForward, Props>(({
    onChange, className, maxSize, multiple = false,
    accept = 'image/png, image/jpeg, image/bmp, image/heic, image/heif',
    onError, children, isSuccess = false
}, providedRef) => {

    const [dragging, setDragging] = useState(false);
    const resetDragging = () => setDragging(false);

    const ref = providedRef ?? createFileUploaderRef();
    const { browse } = useFileUploader(ref);

    const commit = (files: File[]) => {
        onChange(files);
    };

    const onDrop = () => {
        resetDragging();
    };

    const onDragOver: DragEventHandler = event => {
        event.preventDefault();
        setDragging(event.dataTransfer.items[0].kind === 'file');
    };

    const formClassName = classNames(styles.form, className, {
        [styles.dragging]: dragging,
        [styles.valid]: isSuccess
    });

    return (
        <DropArea
            className={formClassName} onClick={browse}
            maxSize={maxSize} ref={ref} multiple={multiple}
            onDrop={onDrop} onChange={commit} onError={onError}
            onDragOver={onDragOver} onDragLeave={resetDragging}>

            <div className={styles.container}>
                <div className={styles.box}>
                    <div className={styles.body}>
                        <DropzoneBody
                            isSuccess={isSuccess} dragging={dragging}
                            accept={accept} />
                    </div>
                </div>
            </div>

            {children}
        </DropArea>
    );
});

export type Props = PropsWithChildren<{
    maxSize: number;
    onChange: (files: File[]) => void;
    onError: (errors: UploadError[]) => void;
    accept?: string;
    multiple?: boolean;
    className?: string;
    isSuccess?: boolean;
}>;